import { useEffect, useState } from 'react'
import { Typography } from '@pw-tech/omni-ui'
import { SIGN_UP_ORDER_TYPE, SUB_STATISTICS } from '@utils/translation'
import { useAmbassadorContext } from '@context/context'
import {
  COMMISSION_VIEW_ORGANIZATIONAl_DATA,
  filteritems,
} from '@utils/StaticDataSet'
import { PROFILE_STAGE, PROGRAM_TYPE } from '@utils/enum'
import StatisticsData from '../StatisticsData/StatisticsData'
import { FilterDropdown } from '@components/PerformanceReport/FilterDropDown/FilterDropDown'
import TermConditionModel from '@components/Common/Term&ConditionModel/Term&ConditionModel'
import ModernTabs from 'common/ModernTabs/ModernTabs'
import { groupList } from '@utils/types'

const Statistics = ({ cameFrom }: { cameFrom?: string }) => {
  const { myProfileValue } = useAmbassadorContext()

  const [applyYearlyMetrics, setApplyYearlyMetrics] = useState<boolean>(false)
  const [startDateFilter, setStartDateFilter] = useState<string>('')
  const [endDateFilter, setEndDateFilter] = useState<string>('')
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [activeHeader, setActiveHeader] = useState<string>('')
  const [activeOrgIndex, setActiveOrgIndex] = useState<string>('')
  const [grouplist, setGrouplist] = useState<groupList[]>([])
  const [resetKey, setResetKey] = useState<number>(0)

  const handleTimerFiler = () => {
    const last30Days = new Date()
    last30Days.setDate(last30Days.getDate() - 30)
    const lastDate = new Date()
    lastDate.setDate(lastDate.getDate() - 1)

    setStartDateFilter(last30Days.toISOString())
    setEndDateFilter(lastDate.toISOString())
    setApplyYearlyMetrics(false)
  }

  const handleActiveHeader = (activeTab: groupList) => {
    handleTimerFiler()
    setResetKey((prev) => prev + 1)
    setActiveOrgIndex(activeTab?.orgId)
    setActiveHeader(activeTab?.orgName)
  }

  useEffect(() => {
    handleTimerFiler()
  }, [])

  useEffect(() => {
    if (!activeOrgIndex) {
      setGrouplist(COMMISSION_VIEW_ORGANIZATIONAl_DATA)
      setActiveHeader(COMMISSION_VIEW_ORGANIZATIONAl_DATA[0]?.orgName)
      setActiveOrgIndex(COMMISSION_VIEW_ORGANIZATIONAl_DATA[0]?.orgId)
    }
  }, [!activeOrgIndex])

  return (
    <div className="mt-5">
      {/* <div className="flex justify-between  items-center gap-2 py-3 px-5 bg-[#FFF6E5] rounded-b-md">
        <span className="flex gap-2">
          <InformationCircleIcon className="right-0 w-5 h-5 my-auto" />
          <Typography variant={'regular'} weight={400}>
            {STATISTICS_ALERT_MESSAGE}
            <Typography weight={600}> {EFFECTIVE_FROM}</Typography>
          </Typography>
        </span>
        <span
          className="text-[#037CBF] hover:text-[#5A4BDA] pl-1 cursor-pointer text-[12px] sm:text-[16px] text-center"
          onClick={() => setIsOpen(true)}
        >
          {TERMS_CONDITIONS}
        </span>
      </div> */}
      {myProfileValue?.programType != PROFILE_STAGE.SAATHI_PROGRAM &&
        cameFrom !== PROGRAM_TYPE.CSC_PROGRAM && (
          <div className="overflow-x-auto scrollbar-hide">
            <ModernTabs
              btnSize="mx-[26px]"
              items={grouplist}
              currentIndex={activeHeader}
              onChange={(args) => handleActiveHeader(args)}
            />
          </div>
        )}

      <div className="py-[32px] px-[24px] rounded-md  bg-[#fff] gap-6 shadow-md">
        <div className="flex justify-between">
          <Typography variant={'heading3'} weight={'semi-bold'} color="#33333">
            {SUB_STATISTICS}
          </Typography>

          {myProfileValue?.programType !== PROFILE_STAGE.SAATHI_PROGRAM && (
            <div className="flex gap-5">
              <FilterDropdown
                items={filteritems}
                resetKey={resetKey}
                startDate={startDateFilter}
                endDate={endDateFilter}
                setStartDateFilter={setStartDateFilter}
                setEndDateFilter={setEndDateFilter}
                applyYearlyMetrics={(item: boolean) =>
                  setApplyYearlyMetrics(item)
                }
                cameFrom={cameFrom}
              ></FilterDropdown>
            </div>
          )}
        </div>
        <StatisticsData
          startDate={startDateFilter}
          endDate={endDateFilter}
          applyYearlyMetrics={applyYearlyMetrics}
          cameFrom={cameFrom}
          orderType={Number(activeOrgIndex)}
        />
        {Number(activeOrgIndex) === SIGN_UP_ORDER_TYPE && (
          <Typography
            weight={'bold'}
            variant="small"
            color="#757575"
            className="ml-2 text-center italic mx-auto mt-4"
          >
            *Sign-Up payout is processed once at least 5% of your sign-ups
            convert.
          </Typography>
        )}
      </div>
      {isOpen && (
        <TermConditionModel
          isTermOpen={isOpen}
          onClose={() => setIsOpen(false)}
          cameFrom={'Statistics'}
        />
      )}
    </div>
  )
}
export default Statistics
